import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { dropRemovedUploadEntries } from './slice';
import type {
  UploaderItemsAppState,
  UploadItem,
  UploadItemError,
} from './types';

const initialState: UploaderItemsAppState = {};

type SetErrorPayload = { stateId: string; error?: UploadItemError };

export const uploaderItemsSlice = createSlice({
  name: 'uploader_items',
  initialState,
  reducers: {
    uploaderItemsAdded: (
      state,
      action: PayloadAction<Record<string, UploadItem>>,
    ) => {
      Object.assign(state, action.payload);
    },
    uploaderItemErrorSet: (state, action: PayloadAction<SetErrorPayload>) => {
      const { stateId, error } = action.payload;
      state[stateId] = { ...state[stateId], error };
    },
  },
  extraReducers: dropRemovedUploadEntries,
});

export const { uploaderItemsAdded, uploaderItemErrorSet } =
  uploaderItemsSlice.actions;

export const uploaderItemsReducer = uploaderItemsSlice.reducer;
